/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
intra_module.factory('WallsService', function($q, Term, Walls) {
    let WallsService;
    return new (WallsService = class WallsService {
        constructor() {
            this.walls    = {
                static: [],
                promo:  []
            };
            this.promises = {
                static:      null,
                static_tags: null,
                promo:       null
            };
            this.unread = {
                total: 0,
                raw:   []
            };
            this.tags =
                {static: { }};

            this.fetchStaticWalls();
            this.fetchStaticTags();
            this.fetchPromoWalls();
            this.fetchUnreadConversations();
        }

        fetchStaticWalls() {

            if (null !== this.promises.static) { return this.promises.static; }

            const deferred = $q.defer();

            Walls
            .query()
            .$promise
            .then(statics_wall => {
                this.walls.static.length = 0;

                for (let wall of Array.from(statics_wall)) { this.walls.static.push({ name: wall, nb_unread: 0 }); }

                return deferred.resolve(this.walls.static);
			}).catch(error => deferred.reject(error));
          return this.promises.static = deferred.promise;
        }

        fetchStaticTags() {

            if (null !== this.promises.static_tags) { return this.promises.static_tags; }

            const deferred = $q.defer();

            Walls.getTags()
            .$promise
            .then(tags => {
                this.tags.static = tags;

                return deferred.resolve(this.tags.static);
        }).catch(error => deferred.reject(error));

            return this.promises.static_tags = deferred.promise;
        }

        fetchPromoWalls() {

            if (null !== this.promises.promo) { return this.promises.promo; }

            const deferred   = $q.defer();
            Term
            .query()
            .$promise
            .then(promo_wall => {
                this.walls.promo.length = 0;

                promo_wall = promo_wall.map(promo => promo.wall_name).filter((wall_name, index, self) => self.indexOf(wall_name) === index);

                for (let wall of Array.from(promo_wall)) { this.walls.promo.push({ name: wall, nb_unread: 0 }); }

                return deferred.resolve(this.walls.promo);
        }).catch(error => deferred.reject(error));

            return this.promises.promo = deferred.promise;
        }

        fetchUnreadConversations() {
            let statics_unread = Walls.getUnreadForStaticsWall().$promise;
            let terms_unread   = Term.getUnreadForTermsWall().$promise;

            return $q
            .all([statics_unread, terms_unread, this.promises.static, this.promises.promo])
            .then(resolve => {
                let unread;
                this.unread.total = 0;
                this.unread.raw   = [];
                [statics_unread, terms_unread] = Array.from(resolve);
                this.unread.raw   = statics_unread.walls.buckets.concat(terms_unread.walls.buckets);
                for (unread of Array.from(this.unread.raw)) { this.unread.total += unread.doc_count; }

                const getUnreadForWall = wall => {
                    for (unread of Array.from(this.unread.raw)) {
                        if (unread.key === wall.name) {
                            return wall.nb_unread = unread.doc_count;
                        }
                    }

                    wall.nb_unread = 0;
                    return wall;
                };

                this.walls.static.map(getUnreadForWall);
                return this.walls.promo.map(getUnreadForWall);
        }).catch(error => console.error('Unread conversation error'));
        }

        getStaticWalls() {
            return this.walls.static;
        }

        getPromoWalls() {
            return this.walls.promo;
        }

        getUnread() {
            return this.unread;
        }
    });
});
